export default __webpack_public_path__ + "static/media/subaru.218b3163.png";